import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { ApplicationConfig, mergeApplicationConfig, importProvidersFrom } from '@angular/core';
import { appConfig } from './app/app.config';
import { ENVIRONMENT } from './app/core/auth/environment.token';

interface Environment {
  api: string;
  webview: string;
  apiKey: string;
  production: boolean;
  urlApi: string;
  signinPolicyName: string;
  clientId: string;
  tenantName: string;
}

function loadConfig(): Promise<Environment> {
  return fetch('/assets/config/environment.json')
    .then(response => response.json())
    .then(config => {
      (window as any)['envConfig'] = config;
      return config as Environment;
    });
}

function createConfig(envConfig: Environment): ApplicationConfig {
  const environmentConfig: ApplicationConfig = {
    providers: [
      importProvidersFrom(),
      {
        provide: ENVIRONMENT,
        useValue: envConfig
      },
      {
        provide: 'API_URL',
        useValue: envConfig.api
      },
      {
        provide: 'WEBVIEW_URL',
        useValue: envConfig.webview
      },
      {
        provide: 'API_KEY',
        useValue: envConfig.apiKey
      },
      {
        provide: 'URL_API',
        useValue: envConfig.urlApi
      },
      {
        provide: 'SIGNIN_POLICY_NAME',
        useValue: envConfig.signinPolicyName
      },
      {
        provide: 'CLIENT_ID',
        useValue: envConfig.clientId
      },
      {
        provide: 'TENANT_NAME',
        useValue: envConfig.tenantName
      }
    ]
  };
  return mergeApplicationConfig(appConfig, environmentConfig);
}

loadConfig()
  .then(envConfig => {
    const config = createConfig(envConfig);
    return bootstrapApplication(AppComponent, config);
  })
  .catch((err) => console.error(err));